module.exports = __webpack_public_path__ + "img/cctv-traffic-disable.b5effaa6.png";